
export const mapboxApiAccessToken = 'pk.eyJ1Ijoibmlja2ptb3J0b24iLCJhIjoiY2p3eGI5ZWFwMGQzbzQ0b3dpdTk0dHVuOCJ9.mQn4q4LyMmU2QsEjnubnnA';

export const defaultMapState = {
  latitude: -37.384150,
  longitude: 143.954081,
  zoom: 17,
};

// export const defaultMapState = {
//   latitude: -24.25,
//   longitude: 133.416667,
//   zoom: 4,
// };

export const staticMapProps = {
  width: '100%',
  height: '100%',
  //mapStyle: 'mapbox://styles/mapbox/satellite-v9',
  mapboxApiAccessToken,
};
